import { commonFilter } from './filter';

export default {
  pageName: 'News',
  pageId: '20110',
  pagePath: '/opinion/News',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
